export const trackingInterval = [
  {value: 60, text: "1"},
  {value: 120, text: "2"},
  {value: 180, text: "3"},
  {value: 240, text: "4"},
  {value: 300, text: "5"},
  {value: 600, text: "10"}
];
